import { c as _c } from "react/compiler-runtime";
import { StatusTag } from '@/components/shared/statusTag';
export function ClassificationChip(t0) {
  const $ = _c(4);
  const {
    label,
    status
  } = t0;
  const statusValue = status === "on" ? "active" : "inactive";
  const icon = status === "on" ? "material-symbols-motion-play-outline-rounded" : "mdi-stop-circle-outline";
  let t1;
  if ($[0] !== icon || $[1] !== label || $[2] !== statusValue) {
    t1 = <StatusTag status={statusValue} label={label} icon={icon} />;
    $[0] = icon;
    $[1] = label;
    $[2] = statusValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}